import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=9ad63b3e&scoped=true&"
var script = {}
import style0 from "./AddButton.vue?vue&type=style&index=0&id=9ad63b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad63b3e",
  null
  
)

export default component.exports